/* eslint-disable max-len */
import Dispatchers from '@/mixins/dispatchers';
const BastanteoItem = () => import(/* webpackChunkName: "BastanteoItem" */ '@/views/shared/bastanteo/bastanteo-item');

export default {
    name: 'BastanteoOthers',

    mixins: [Dispatchers],

    components: {
        BastanteoItem
    },

    /**
     * @override
     */
    data() {
        return {
            opened: false
        };
    },
    props: {
        itemActive: {
            type: String | Object,
            required: false
        },
        items: {
            items: Array | Object,
            required: true
        }
    },

    methods: {
        /**
         * Muestra documento en ventana flotante
         * @param {Object} item documento a mostrar
         */
        showDocumentInWindow(item) {
            const typeData = {
                type: item.type,
                uuid: item.uuid,
                is_validated: item.is_validated
            };
            item = item.data;
            item.type = typeData;
            this.$store.dispatch('bastanteoStore/setNewFloatWindow', item);
        }

    }

};
